import { useState, useEffect } from 'react';
import {
  networkQualityService,
  NetworkState,
  NetworkQuality,
} from '../services/network/network-quality.service';

const QUALITY_LABELS: Record<NetworkQuality, string> = {
  [NetworkQuality.Excellent]: 'Connessione ottima',
  [NetworkQuality.Good]: 'Connessione buona',
  [NetworkQuality.Tolerable]: 'Connessione lenta',
  [NetworkQuality.Poor]: 'Connessione scarsa',
  [NetworkQuality.Offline]: 'Offline',
};

const QUALITY_COLORS: Record<NetworkQuality, string> = {
  [NetworkQuality.Excellent]: '#22c55e',
  [NetworkQuality.Good]: '#22c55e',
  [NetworkQuality.Tolerable]: '#f59e0b',
  [NetworkQuality.Poor]: '#ef4444',
  [NetworkQuality.Offline]: '#6b7280',
};

export function useNetworkQuality() {
  const [state, setState] = useState<NetworkState>(networkQualityService.currentState);

  useEffect(() => {
    const unsubscribe = networkQualityService.subscribe(setState);
    return unsubscribe;
  }, []);

  return {
    ...state,
    canUseApi: networkQualityService.canUseApi,
    isOffline: networkQualityService.isOffline,
    isSlowConnection:
      state.quality === NetworkQuality.Tolerable || state.quality === NetworkQuality.Poor,
    label: QUALITY_LABELS[state.quality],
    color: QUALITY_COLORS[state.quality],
    reevaluate: () => networkQualityService.reevaluate(),
  };
}
